export default {
    fleetModalUpdateUnit_unit: "Unidad",
    fleetModalUpdateUnit_asset: "Activo",
    fleetModalUpdateUnit_inputOutput: "Entrada-Salida",
    fleetModalUpdateUnit_notes: "Notas",
    fleetModalUpdateUnit_tags: "Etiquetas",
    fleetModalUpdateUnit_assetType: "Tipo",
    fleetModalUpdateUnit_assetSubType: "Subtipo",
    fleetModalUpdateUnit_licensePlate: "Matrícula",
    fleetModalUpdateUnit_registrationCountry: "País del Registro",
    fleetModalUpdateUnit_registrationState: "Estado del Registro",
    fleetModalUpdateUnit_registrationExpiration: "Fecha de expiración del Registro",
    fleetModalUpdateUnit_vin: "VIN",
    fleetModalUpdateUnit_make: "Marca",
    fleetModalUpdateUnit_model: "Modelo",
    fleetModalUpdateUnit_year: "Año",
    fleetModalUpdateUnit_engineLiters: "Litros del Motor",
    fleetModalUpdateUnit_highway: "Carretera",
    fleetModalUpdateUnit_city: "Ciudad",
    fleetModalUpdateUnit_inspectionDeviceType: "Tipo de Dispositivo de Inspección",
    fleetModalUpdateUnit_inspectionTagID: "ID de Etiqueta de Inspección",
    fleetModalUpdateUnit_isELDEnabled: "¿ELD Activado?",
    fleetModalUpdateUnit_powerUnitNumber: "Número de Unidad Motriz",
    fleetModalUpdateUnit_toogle: "Activar/Desactivar",
    fleetModalUpdateUnit_pulse: "Pulso Activado/Desactivado",
    fleetModalUpdateUnit_single: "Pulso Único",
    fleetModalUpdateUnit_inputLabel: "Etiqueta de Entrada",
    fleetModalUpdateUnit_outputLabels: "Etiqueta de Salida",
    fleetModalUpdateUnit_tagsLabel: "Esta unidad pertenece a las siguientes etiquetas:",
    fleetModalUpdateUnit_addTags: "Agregar Etiquetas",
    fleetModalUpdateUnit_decodeVin: "Decodificar VIN",
    fleetModalUpdateUnit_maxValue: "Valor Máximo",
    fleetModalUpdateUnit_minValue: "Valor Mínimo",
    fleetModalUpdateUnit_unitLabelAndIcon: "Etiqueta e Icono de la Unidad",
    fleetModalUpdateUnit_enableAndDisabled: "Activar Todo / Desactivar Todo",
    fleetModalUpdateUnit_disabled: "Desactivar Todo",
    fleetModalUpdateUnit_enable: "Activar Todo",
    fleetModalUpdateUnit_speed: "Velocidad",
    fleetModalUpdateUnit_calculatedByEcu: "Calculado por ECU",
    fleetModalUpdateUnit_calculatedByGps: "Calculado por GPS",
    fleetModalUpdateUnit_odometer: "Odómetro",
    fleetModalUpdateUnit_dashReading: "Lectura del Tablero",
    fleetModalUpdateUnit_lastUpdated: "Última Actualización",
    fleetModalUpdateUnit_engineHours: "Horas del Motor",
    fleetModalUpdateUnit_actual: "Actual",
    fleetModalUpdateUnit_assignedDriver: "Conductor Asignado",
    fleetModalUpdateUnit_defaultDriver: "Conductor Predeterminado",
    fleetModalUpdateUnit_driverDefaultInfo: `El conductor principal se asignará automáticamente como el "Conductor Asignado" cuando el vehículo esté en movimiento sin un conductor asignado. La asignación del conductor se basará en el valor establecido en el campo "Conductor Predeterminado".`,
    fleetModalUpdateUnit_location: "Ubicación",
    fleetModalUpdateUnit_timezone: "Zona Horaria",
    fleetModalUpdateUnit_consistentSpeed: "Velocidad Constante",
    fleetModalUpdateUnit_custom: "Personalizar",
    fleetModalUpdateUnit_duplicatedLabel: "La etiqueta ya está en uso",
    fleetModalUpdateUnit_duplicatedlicensePlace: "La matrícula ya está en uso",
    fleetModalUpdateUnit_duplicatedVin: "El VIN ya está en uso",
    fleetModalUpdateUnit_errorVin: "VIN inválido, debe tener 17 caracteres alfanuméricos, sin I, O o Q, sin caracteres especiales ni espacios, y con un dígito de control válido en la novena posición",
    fleetModalUpdateUnit_warningVinCheckDigit: "VIN decodificado, pero su dígito de control (novena posición) es incorrecto, por lo que los datos podrían ser inexactos. Verifica el VIN; podría ser rechazado al guardar.",
    fleetModalUpdateUnit_successMessage: "La unidad se ha actualizado correctamente",
    fleetModalUpdateUnit_duplicatedTagId: "El ID de la etiqueta de inspección ya está en uso",
    fleetModalUpdateUnit_status: "Estado",
    fleetModalUpdateUnit_enterExternalId: "Introducir Id Externo",
    fleetModalUpdateUnit_none: "Ninguno",
    fleetModalUpdateUnit_requiredFields: "Todos los campos obligatorios deben estar rellenados y contener valores válidos para continuar",
    fleetModalUpdateUnit_alert_title: "Error de validación",
    fleetModalUpdateUnit_licensePlateErrorLength: "La matrícula debe tener entre 4 y 20 caracteres",
    
    fleetModalUpdateUnit_maintenanceCompany_none: "Sin Compañía de Mantenimiento",
    fleetModalUpdateUnit_maintenanceCompany_idealease: "Idealease",
    fleetModalUpdateUnit_maintenanceCompany_nationalease: "Nationalease",
    fleetModalUpdateUnit_maintenanceCompany_noregon: "Noregon",
    fleetModalUpdateUnit_maintenanceCompany_penske: "Penske",
    fleetModalUpdateUnit_maintenanceCompany_ryder: "Ryder",
    fleetModalUpdateUnit_maintenanceCompany_other: "Otra Compañía de Mantenimiento",
    fleetModalUpdateUnit_labelEmpty: "La etiqueta no puede estar vacía",
}